module.exports = __webpack_public_path__ + "static/media/tb3.0e723668.jpg";